<div class="layout" #layout>
  <div class="form" #form>
    <div
      *ngIf="headerGroup && !(headerGroup.props.isHidden$ | async)"
      class="form__header"
      #header
    >
      <formly-field [field]="headerGroup"></formly-field>
    </div>

    <div class="form__content" #content>
      <formly-field [field]="contentGroup"></formly-field>
      <formly-field
        *ngFor="let config of otherFields"
        [field]="config"
      ></formly-field>
    </div>

    <div
      *ngIf="footerGroup && !(footerGroup.props.isHidden$ | async)"
      class="form__footer"
      #footer
    >
      <formly-field [field]="footerGroup"></formly-field>
    </div>

    <div
      *ngIf="underFormGroup && !(underFormGroup.props.isHidden$ | async)"
      class="form__under-form"
    >
      <formly-field [field]="underFormGroup"></formly-field>
    </div>
  </div>
  <div
    *ngIf="pageFooterGroup && !(pageFooterGroup.props.isHidden$ | async)"
    class="layout__footer"
  >
    <formly-field [field]="pageFooterGroup"></formly-field>
  </div>
</div>
